// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sensor label styling copied/adapted from original viewer */
.sensor-card{
    background: rgba(255,255,255,0.95);
    border: 1px solid rgba(0,0,0,0.12);
    padding: 6px 8px;
    border-radius: 6px;
    font-size: 12px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.12);
    transform-origin: center;
    transform: translateX(-12px);
}
.sensor-card .val{color:#333;margin-top:4px}

.hidden{display:none}
.hidden .sensor-card{pointer-events: none}
.visible{display:block}
.visible .sensor-card{pointer-events: auto}

.persistent .sensor-card{border-right:4px solid var(--accent, #ff3300)}
.lifted .sensor-card{box-shadow: 0 6px 18px rgba(0, 0, 0, 0.24);}

.sensor-card.label-inner{pointer-events:auto}

/* Sensor Editor sidebar (overlay) */
.sensor-editor-root{
    position: absolute;
    right: 8px;
    top: 72px;
    width: 300px;
    max-height: calc(100vh - 96px);
    overflow:auto;
    z-index: 20000;
    font-size: 13px;
}
.sensor-editor{
    background: rgba(250,250,250,0.98);
    border: 1px solid rgba(0,0,0,0.08);
    padding: 12px;
    border-radius: 8px;
    box-shadow: 0 8px 28px rgba(0,0,0,0.12);
}
.sensor-editor h3{margin:0 0 10px 0;font-size:15px}
.sensor-editor .field{display:flex;gap:8px;align-items:center;margin-bottom:8px}
.sensor-editor .field label{width:70px;font-weight:600}
.sensor-editor .field input{flex:1;padding:6px;border:1px solid #ddd;border-radius:4px}
.sensor-editor .field.offsets label{width:60px}
.sensor-editor .buttons{display:flex;flex-wrap:wrap;gap:6px;margin-top:6px}
.sensor-editor .buttons button{flex:1;padding:6px}
.se-msg{margin-top:8px;font-size:12px}
`, "",{"version":3,"sources":["webpack://./src/lib/styles.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;IACI,kCAAkC;IAClC,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,wBAAwB;IACxB,4BAA4B;AAChC;AACA,kBAAkB,UAAU,CAAC,cAAc;;AAE3C,QAAQ,YAAY;AACpB,qBAAqB,oBAAoB;AACzC,SAAS,aAAa;AACtB,sBAAsB,oBAAoB;;AAE1C,yBAAyB,6CAA6C;AACtE,qBAAqB,0CAA0C,CAAC;;AAEhE,yBAAyB,mBAAmB;;AAE5C,oCAAoC;AACpC;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,cAAc;IACd,eAAe;AACnB;AACA;IACI,kCAAkC;IAClC,kCAAkC;IAClC,aAAa;IACb,kBAAkB;IAClB,uCAAuC;AAC3C;AACA,kBAAkB,iBAAiB,CAAC,cAAc;AAClD,sBAAsB,YAAY,CAAC,OAAO,CAAC,kBAAkB,CAAC,iBAAiB;AAC/E,4BAA4B,UAAU,CAAC,eAAe;AACtD,4BAA4B,MAAM,CAAC,WAAW,CAAC,qBAAqB,CAAC,iBAAiB;AACtF,oCAAoC,UAAU;AAC9C,wBAAwB,YAAY,CAAC,cAAc,CAAC,OAAO,CAAC,cAAc;AAC1E,+BAA+B,MAAM,CAAC,WAAW;AACjD,QAAQ,cAAc,CAAC,cAAc","sourcesContent":["/* Sensor label styling copied/adapted from original viewer */\n.sensor-card{\n    background: rgba(255,255,255,0.95);\n    border: 1px solid rgba(0,0,0,0.12);\n    padding: 6px 8px;\n    border-radius: 6px;\n    font-size: 12px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.12);\n    transform-origin: center;\n    transform: translateX(-12px);\n}\n.sensor-card .val{color:#333;margin-top:4px}\n\n.hidden{display:none}\n.hidden .sensor-card{pointer-events: none}\n.visible{display:block}\n.visible .sensor-card{pointer-events: auto}\n\n.persistent .sensor-card{border-right:4px solid var(--accent, #ff3300)}\n.lifted .sensor-card{box-shadow: 0 6px 18px rgba(0, 0, 0, 0.24);}\n\n.sensor-card.label-inner{pointer-events:auto}\n\n/* Sensor Editor sidebar (overlay) */\n.sensor-editor-root{\n    position: absolute;\n    right: 8px;\n    top: 72px;\n    width: 300px;\n    max-height: calc(100vh - 96px);\n    overflow:auto;\n    z-index: 20000;\n    font-size: 13px;\n}\n.sensor-editor{\n    background: rgba(250,250,250,0.98);\n    border: 1px solid rgba(0,0,0,0.08);\n    padding: 12px;\n    border-radius: 8px;\n    box-shadow: 0 8px 28px rgba(0,0,0,0.12);\n}\n.sensor-editor h3{margin:0 0 10px 0;font-size:15px}\n.sensor-editor .field{display:flex;gap:8px;align-items:center;margin-bottom:8px}\n.sensor-editor .field label{width:70px;font-weight:600}\n.sensor-editor .field input{flex:1;padding:6px;border:1px solid #ddd;border-radius:4px}\n.sensor-editor .field.offsets label{width:60px}\n.sensor-editor .buttons{display:flex;flex-wrap:wrap;gap:6px;margin-top:6px}\n.sensor-editor .buttons button{flex:1;padding:6px}\n.se-msg{margin-top:8px;font-size:12px}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
